const Systems ="laxy666" 

export default Systems;
